import App from "./App";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";

const app = ReactDOM.createRoot(document.getElementById("root"));

app.render(<App />);
